export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_04_powereddge_facts-end.72b14cbe.jpg";